export default __webpack_public_path__ + "static/media/sms-logo.5343a5c6.png";